import { AssignedToFilterValueProvider } from "WorkItemTracking/Scripts/Controls/Filters/FilterValueProviders";
import { IFilterDataSource, FilterValue } from "WorkItemTracking/Scripts/Filtering/FilterManager";
import { IWorkItemFilterItem,  IWorkItemFilterPickListItemResult, workItemFilterItemComparer } from "WorkItemTracking/Scripts/Controls/Filters/WorkItemFilter";
import { isPromise, makePromise, IOptionalPromise } from "Presentation/Scripts/TFS/TFS.Core.Utils";
import { subtract } from "VSS/Utils/Array";
import * as TaskboardResources from "Agile/Scripts/Resources/TFS.Resources.AgileTaskboard";

export const AllFilterItem: IWorkItemFilterItem = {
    key: "_All_",
    display: TaskboardResources.Taskboard_FilterValue_All,
    value: TaskboardResources.Taskboard_FilterValue_All
};
/**
 * Populates the options the PoepleSwitcherCallout
 * Takes all values from AssignedToFilterValueProvider and adds 'All' macro in the first position
 */
export class PeopleSwitcherValueProvider extends AssignedToFilterValueProvider {
    constructor(dataSource: IFilterDataSource) {
        super(dataSource);
    }

    getItems(persistedValues?: FilterValue[]): IOptionalPromise<IWorkItemFilterItem[]> {
        const values = super.getItems(persistedValues);
        if (isPromise(values)) {
            return values.then(this.addAllMacro);
        } else {
            return this.addAllMacro(values);
        }
    }

    getItemsForValues(values: FilterValue[]): IOptionalPromise<IWorkItemFilterItem[]> {
        const results: IPromise<IWorkItemFilterItem>[] = [];
        for (const value of values) {
            if (value === AllFilterItem.value) {
                results.push(Q(AllFilterItem));
            }  else {
                results.push(makePromise(super.getItemsForValues([value])).then(r => r[0]));
            }
        }
        return Q.all(results);
    }

    getListItem(listItem: IWorkItemFilterItem): IWorkItemFilterPickListItemResult {
        if (listItem.key === AllFilterItem.key) {
            return {
                item: {
                    key: listItem.key,
                    name: listItem.display,
                    value: listItem.value,
                }
            };
        }
        const pickListItem = super.getListItem(listItem)
        if(pickListItem.item && pickListItem.item.iconProps) {
            pickListItem.item.iconProps.className = "people-switcher-people-icon";
        }
        return pickListItem;
    }

    private addAllMacro(values: IWorkItemFilterItem[]): IWorkItemFilterItem[] {
        const macros = [AllFilterItem];
        // make sure there are no macro dupes that came from persisted values.
        values = subtract(values, macros, workItemFilterItemComparer);
        return macros.concat(values);
    }
}